import { FunctionComponent as F, ReactNode } from "react";
import Typography from '@mui/material/Typography';
import TextTooltip from "../UI/Tooltip/TextTooltip";

interface IProps
{
  text?: string | number,
  textColor?: string,
  tooltip?: ReactNode[];
  fontSize?: number,
  bold?: boolean
}


const CostBreakdownTextValue: F<IProps> = (props: IProps) =>
{
  const fontSize = props.fontSize || 11;
  const fontWeight = props.bold ? 'bold' : 'normal';
  const color = props.textColor || 'black';


  return (props.tooltip ?
    <TextTooltip lines={props.tooltip}>
      <Typography variant='body2' style={{ fontSize, fontWeight, color }}>
        {props.text || ""}
      </Typography>
    </TextTooltip> :
    <Typography variant='body2' style={{ fontSize, fontWeight, color }}>
      {props.text || ""}
    </Typography>);
};

export default CostBreakdownTextValue;
